import { useTranslation } from 'react-i18next';
import { useSetPageHeader } from '@/components/chrome/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { CalendarSettingsPanel } from '@/components/settings/CalendarSettingsPanel';

export default function CalendarSettingsPage() {
  const { t } = useTranslation('calendar');

  useSetPageHeader({ title: t('title'), sub: t('subtitle') }, [t]);

  return (
    <Card>
      <CardContent className="px-4 sm:px-6 py-6">
        <CalendarSettingsPanel showHeader={false} />
      </CardContent>
    </Card>
  );
}
